import {isValid, touch} from 'redux-form'

/**
 * @deprecated Use handleSubmitWithControlForm instead. This function has a know issue that causes either the main form or the control-form fields to be touched, not both.
 */
const handleControlForm = fn => data => {
  const state = window.store.getState(),
    dispatch = window.store.dispatch,
    formData = state.form['control-form'],
    fields = formData && formData.registeredFields && Object.keys(formData.registeredFields)

  if (fields && fields.length) {
    dispatch(touch('control-form', ...fields))
  }

  if (!formData || isValid('control-form')(state)) {
    fn(data)
  }
}

export {handleControlForm}
